import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { prettifyGeneratedName as prettifyGenerated } from '../utils/examNames';

const GeneratedExams = () => {
  const { oppositionName } = useParams();
  const navigate = useNavigate();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`/api/exams/generated/${encodeURIComponent(oppositionName)}`);
        if (!cancelled) setExams(r.data);
      } catch (e) {
        console.error(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [oppositionName]);

  if (loading) return <div className="page-loader">Cargando exámenes…</div>;

  return (
    <div>
      <button onClick={() => navigate(`/oposicion/${oppositionName}`)} className="back-link">← Volver</button>
      <header className="page-header">
        <h1 className="page-title">Exámenes generados por IA</h1>
        <p className="page-subtitle">
          {oppositionName} · {exams.length} disponibles · basados en el patrón de los oficiales
        </p>
      </header>

      <div style={{ background: '#fff7ed', border: '1px solid #fed7aa', color: '#9a3412', padding: '0.7rem 1rem', borderRadius: 8, marginBottom: 16, fontSize: '0.9em' }}>
        ⚠️ Estos exámenes son <strong>generados con IA</strong> a partir de la distribución de artículos de los exámenes oficiales. Úsalos para practicar, pero contrasta siempre con la ley si tienes dudas — pueden contener errores.
      </div>

      {exams.length === 0 ? (
        <div className="empty-state">
          <p>Todavía no hay exámenes generados para esta oposición.</p>
        </div>
      ) : (
        <div className="list-grid">
          {exams.map((e) => (
            <Link key={e.name} to={`/exam/generado/${encodeURIComponent(e.name)}`} className="list-item">
              <div>
                <div className="list-item-title">{prettifyGenerated(e.name)}</div>
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                  {e.questions} preguntas · generado por IA
                </div>
              </div>
              <span className="list-item-arrow">→</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default GeneratedExams;
